import React, { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../api/api";
import {
  createDownload,
  fetchDownloads,
} from "../../../features/downloads/downloadSlice";
import Images from "../../../media/images";
import PublicDownloadView from "./PublicDownloadView";

const StaffDownloadUpload = () => {
  const [changes, setChanges] = useState(true)
  const [publicDownloadList, setPublicDownloadList] = useState({})

  const [del, setDel] = useState(false)

  // const downloads = useSelector((state) => state.downloads?.downloads);
  const [downloads, setDownloads] = useState([])

  useEffect(() => {
    dispatch(fetchDownloads(setDownloads));
  }, [changes, del]);


  
  const { register, handleSubmit } = useForm();
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    // data.is_published = true

    const formData = new FormData();
    formData.append("file", data.files[0]);
    formData.append("title", data.document);
    formData.append("is_published", true)
    dispatch(createDownload(formData));
    setChanges(!changes)

    toast.success("Docs Created")
  };


  const deleteDownloadList = (id) => {
    api
      .delete(`/downloads/${id}/`)
      .then((response) => {
        toast.success("Successfully deleted")
        setDel(!del);
      })
      .catch((error) => {
        toast.error("Unable to delete");
      });
  };


  const handleSearch = (e) => {
    api.get(`/downloads/?search=${e.target.value}`)
    .then(response=> {
     
        setDownloads(response.data)
    }).catch(error=>  {
      console.log("error")
    })
    
  }





  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Public Download and Upload Details
      </h1>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>
      {/* pdf and jpeg */}
      <div className="p-3 md:!p-10">
        <p className="text-primary-blue mt-5 font-bold underline">
          1. Pdf and jpeg file
        </p>
        {/* upload */}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex flex-wrap items-center justify-between gap-0"
        >
          <div className="">
            <input
              type="file"
              name=""
              className="text-primary-blue file:bg-primary-red ml-3 outline-none file:rounded-lg file:text-white"
              id=""
              {...register("files", { required: true })}
            />
            <input
              placeholder="Document Name"
              type="text"
              className="my-3 rounded-lg border border-black p-3"
              {...register("document", { required: true })}
            />

            <input
              value="submit"
              type="submit"

              className="bg-primary-red ml-10 inline-flex gap-2 rounded-md px-5 py-3 font-bold text-white"
            />
          </div>
          <input
            placeholder="Search by name"
            onChange={e => handleSearch(e)}
            type="text"
            className="my-3 content-end rounded-lg border border-black p-3"
          />
        </form>
        <div className="overflow-x-scroll">
          <table className="border-primary-blue min-w-full border text-center">
            <thead className="font-Bree bg-primary-red text-lg font-bold">
              <tr className="">
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  SN.
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Upload Date
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Document Name
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  File type
                </th>
                <th
                  scope="col"
                  className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="font-Acme">
              {downloads.map((item, index) => {
                return (
                  <tr key={index} className="border-primary-blue border-2 bg-white">
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      {index + 1}
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                     {item.upload_date}
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      {item.title}
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                      {item.file_type}
                    </td>
                    <td className="font-Aladin border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                      <button

                        data-bs-toggle="modal"
                        data-bs-target="#exampleModalEdit"
                        onClick={() => setPublicDownloadList(item)}
                        className="bg-primary-green rounded-full p-1 px-2 text-white"
                      >
                        View
                      </button >
                      <PublicDownloadView publicDownloadList={publicDownloadList} />

                      <button
                        onClick={() => deleteDownloadList(item.id)}
                        className="rounded-full bg-yellow-500 p-1 px-2 text-white"
                      >
                        Delete
                      </button >
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StaffDownloadUpload;
